(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hh-home-moment"] && !Shopify.designMode) return;
  try {
    class HhHomeMoment extends HTMLElement {
  connectedCallback() {
    if (this.hhmTeardown) return;
    const cfg = JSON.parse(this.querySelector('[data-hhm=config]').textContent);
    const T = cfg.text;
    const G = cfg.goals;
    const V = cfg.video;
    const byId = {};
    G.forEach((g) => { byId[g.id] = g; });
    const ac = new AbortController();
    const sig = { signal: ac.signal };
    const q = (s) => this.querySelector(s);
    const el = {
      status: q('[data-hhm=status]'),
      img: q('[data-hhm=img]'),
      name: q('[data-hhm=name]'),
      desc: q('[data-hhm=desc]'),
      badge: q('[data-hhm=badge]'),
      facts: q('[data-hhm=facts]'),
      inside: q('[data-hhm=inside]'),
      details: q('[data-hhm=details]'),
      support: q('[data-hhm=support]'),
      cta: q('[data-hhm=cta]'),
      ctaText: q('[data-hhm=cta-text]'),
      motion: q('[data-hhm=motion]'),
      dialog: q('[data-hhm=dialog]'),
      video: q('[data-hhm=video]'),
      vctl: q('[data-hhm=vctl]'),
      vmsg: q('[data-hhm=vmsg]'),
      close: q('[data-hhm=close]'),
      pvideo: q('[data-hhm=pvideo]')
    };
    const pills = [...this.querySelectorAll('[data-hhm-goal]')];
    const mq = matchMedia('(prefers-reduced-motion: reduce)');
    const cache = new Map();
    let cur = byId[this.dataset.hhmState] ? this.dataset.hhmState : G[0].id;
    let want = cur;
    let tok = 0;
    let opener = null;
    let inView = true;
    let motionOn = true;
    let io = null;
    let pvUpdate = null;
    let pvStop = null;
    cache.set(byId[cur].img, Promise.resolve());

    const load = (u) => {
      if (!cache.has(u)) {
        cache.set(u, new Promise((ok, no) => {
          const i = new Image();
          i.onload = () => ok();
          i.onerror = () => { cache.delete(u); no(); };
          i.src = u;
        }));
      }
      return cache.get(u);
    };
    const mark = () => {
      pills.forEach((p) => {
        const g = p.dataset.hhmGoal;
        p.setAttribute('aria-pressed', String(g === cur));
        p.classList.toggle('hhm-pend', g === want && want !== cur);
      });
    };
    const commit = (k) => {
      const s = byId[k];
      cur = k;
      want = k;
      this.dataset.hhmState = k;
      el.img.src = s.img;
      el.img.alt = s.alt;
      el.name.textContent = s.title;
      el.desc.textContent = s.desc;
      el.badge.textContent = s.badge;
      el.badge.hidden = !s.badge;
      el.facts.replaceChildren(...s.facts.map((x) => {
        const li = document.createElement('li');
        li.className = 'hhm-fact';
        li.textContent = x;
        return li;
      }));
      el.inside.hidden = !s.capsule;
      el.details.hidden = false;
      el.details.href = s.product;
      el.support.textContent = s.support;
      el.ctaText.textContent = s.cta;
      el.cta.href = s.href;
      mark();
      this.querySelectorAll('[data-hhm-rv]').forEach((e, i) => {
        e.classList.remove('hhm-rv');
        void e.offsetWidth;
        e.style.animationDelay = (i * 60) + 'ms';
        e.classList.add('hhm-rv');
      });
    };
    const fail = (k) => {
      const m = document.createElement('span');
      const r = document.createElement('button');
      m.textContent = T.errPre + ' ' + byId[k].label + '. ' + T.errPost;
      r.type = 'button';
      r.textContent = T.retry;
      r.addEventListener('click', () => pick(k), sig);
      el.status.replaceChildren(m, r);
    };
    const pick = (k) => {
      const t = ++tok;
      want = k;
      el.status.replaceChildren();
      mark();
      if (k === cur) return;
      load(byId[k].img).then(
        () => { if (t === tok) commit(k); },
        () => { if (t !== tok) return; want = cur; mark(); fail(k); }
      );
    };
    pills.forEach((p) => p.addEventListener('click', () => pick(p.dataset.hhmGoal), sig));

    const sync = () => {
      this.dataset.hhmRun = (motionOn && !mq.matches && inView && !document.hidden) ? 'on' : 'off';
      if (pvUpdate) pvUpdate();
    };
    const setM = (on) => {
      motionOn = on;
      this.dataset.hhmMotion = on ? 'on' : 'off';
      el.motion.setAttribute('aria-pressed', String(on));
      el.motion.title = mq.matches ? T.motionReduced : (on ? T.motionOn : T.motionOff);
      sync();
    };
    const onMq = () => {
      el.motion.disabled = mq.matches;
      setM(!mq.matches);
    };
    onMq();
    mq.addEventListener('change', onMq, sig);
    el.motion.addEventListener('click', () => setM(!motionOn), sig);
    document.addEventListener('visibilitychange', sync, sig);
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver((entries) => {
        inView = entries[entries.length - 1].isIntersecting;
        sync();
      });
      io.observe(this);
    }

    if (el.pvideo) {
      const pv = el.pvideo;
      const pimg = q('.hhm-portrait');
      let ready = false;
      let attached = false;
      let failed = false;
      let shown = false;
      let fid = 0;
      let raf = 0;
      let idle = 0;
      let timer = 0;
      const eligible = () => ready && !failed && this.dataset.hhmRun === 'on' && !(navigator.connection && navigator.connection.saveData);
      const cancelFrame = () => {
        if (fid) { pv.cancelVideoFrameCallback(fid); fid = 0; }
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
      };
      const hide = () => {
        shown = false;
        cancelFrame();
        pv.classList.remove('hhm-pvideo-on');
      };
      const show = () => {
        fid = 0;
        raf = 0;
        if (eligible() && !pv.paused && pv.readyState >= 2) {
          shown = true;
          pv.classList.add('hhm-pvideo-on');
        }
      };
      const reveal = () => {
        if (shown || fid || raf) return;
        if (pv.requestVideoFrameCallback) fid = pv.requestVideoFrameCallback(show);
        else raf = requestAnimationFrame(() => { raf = requestAnimationFrame(show); });
      };
      const start = () => {
        if (!attached || !eligible() || pv.readyState < 3) return;
        if (pv.paused) {
          const p = pv.play();
          if (p && p.catch) p.catch(hide);
        } else {
          reveal();
        }
      };
      const attach = () => {
        attached = true;
        pv.muted = true;
        pv.defaultMuted = true;
        pv.preload = 'auto';
        pv.src = pv.dataset.src;
      };
      pvUpdate = () => {
        if (eligible()) {
          if (attached) start(); else attach();
        } else {
          pv.pause();
          hide();
        }
      };
      pv.addEventListener('canplay', start, sig);
      pv.addEventListener('playing', () => {
        if (eligible()) reveal();
        else { pv.pause(); hide(); }
      }, sig);
      ['waiting', 'pause', 'emptied'].forEach((e) => pv.addEventListener(e, hide, sig));
      pv.addEventListener('stalled', () => { if (pv.readyState < 3) hide(); }, sig);
      pv.addEventListener('error', () => { failed = true; pv.pause(); hide(); }, sig);
      const loaded = document.readyState === 'complete'
        ? Promise.resolve()
        : new Promise((res) => window.addEventListener('load', res, { once: true, signal: ac.signal }));
      const imaged = new Promise((res) => {
        if (!pimg) return;
        if (pimg.complete) { if (pimg.naturalWidth) res(); return; }
        pimg.addEventListener('load', () => res(), { once: true, signal: ac.signal });
      }).then(() => (pimg.decode ? pimg.decode().catch(() => {}) : null));
      const go = () => {
        idle = 0;
        timer = 0;
        ready = true;
        if (pvUpdate) pvUpdate();
      };
      Promise.all([loaded, imaged]).then(() => {
        if (ac.signal.aborted) return;
        if (window.requestIdleCallback) idle = requestIdleCallback(go, { timeout: 2500 });
        else timer = setTimeout(go, 300);
      });
      pvStop = () => {
        pvUpdate = null;
        if (idle) cancelIdleCallback(idle);
        clearTimeout(timer);
        cancelFrame();
        pv.pause();
        pv.classList.remove('hhm-pvideo-on');
        pv.removeAttribute('src');
        pv.load();
      };
    }

    const label = () => {
      el.vctl.textContent = el.video.ended ? T.replay : (el.video.paused ? T.play : T.pause);
    };
    el.video.muted = true;
    ['play', 'pause', 'ended'].forEach((e) => el.video.addEventListener(e, label, sig));
    el.video.addEventListener('error', () => { el.vmsg.hidden = false; }, sig);
    el.vctl.addEventListener('click', () => {
      el.vmsg.hidden = true;
      if (el.video.paused || el.video.ended) {
        if (el.video.error) el.video.load();
        if (el.video.ended) el.video.currentTime = 0;
        el.video.play().catch(() => { el.vmsg.hidden = false; });
      } else {
        el.video.pause();
      }
    }, sig);
    el.inside.addEventListener('click', () => {
      opener = el.inside;
      if (!el.video.getAttribute('src')) {
        el.video.poster = V.poster;
        el.video.src = V.src;
      }
      el.dialog.showModal();
      if (!mq.matches) el.video.play().catch(() => {});
    }, sig);
    el.close.addEventListener('click', () => el.dialog.close(), sig);
    el.dialog.addEventListener('click', (e) => { if (e.target === el.dialog) el.dialog.close(); }, sig);
    el.dialog.addEventListener('close', () => {
      el.video.pause();
      el.vmsg.hidden = true;
      if (opener) opener.focus();
    }, sig);

    this.hhmTeardown = () => {
      ac.abort();
      if (io) io.disconnect();
      if (pvStop) pvStop();
      tok++;
      el.video.pause();
      if (el.dialog.open) el.dialog.close();
    };
  }

  disconnectedCallback() {
    if (!this.hhmTeardown) return;
    this.hhmTeardown();
    this.hhmTeardown = null;
  }
}

if (!customElements.get('hh-home-moment')) {
  customElements.define('hh-home-moment', HhHomeMoment);
}
  } catch(e) { console.error(e); }
})();

})();
